/** Figma configure card min width at 2xl+. */
export const CONFIGURE_CARD_MIN_WIDTH_PX = 345.333;

/** Same footprint as agent cards: fill the grid cell, never shorter than 240px. */
export const configureCardSizeClassName =
  'h-full min-h-[240px] w-full min-w-0';

/** 1/2/3 cols below 2xl; at 2xl max 3 cols with 345.333px min width; equal card height and width. */
export const configureCardGridClassName =
  'grid min-w-0 auto-rows-[240px] grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-[repeat(3,minmax(345.333px,1fr))] [&>*]:h-full [&>*]:w-full [&>*]:min-w-0';
